import { render, staticRenderFns } from "./OrderAdmittanceUpdateTemplate.vue?vue&type=template&id=4e5d89c7&"
import script from "./OrderAdmittanceUpdateTemplate.vue?vue&type=script&lang=js&"
export * from "./OrderAdmittanceUpdateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QItem,QSelect,QIcon,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QItem,QSelect,QIcon,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn}, component.options.components || {})
